import { Box, Grid, LinearProgress, Typography } from "@material-ui/core";
import React from "react";
import CountUp from "react-countup";

const LinearProgressWithLabel = (props) => {
  return (
    <Grid item xs={12}>
      <Box minWidth={35}>
        <Typography variant="body1" color="textSecondary">
          <CountUp end={Math.round(props.value)} duration={0.5} />%
        </Typography>
      </Box>
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" color={props.color} {...props} />
      </Box>
    </Grid>
  );
};

export default LinearProgressWithLabel;
